export const MANTIS_TEXT_PRIMARY = "#050e2b";
export const MANTIS_TEXT_SECONDARY = "#63697e";
export const MANTIS_BORDER = "#d3d5e0";
export const MANTIS_DIVIDER = "#d3d5e0";
export const MANTIS_BG_PAPER = "#fcfdff";
